import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../actions';
import PersonForm from './PersonForm';
import { Segment } from 'semantic-ui-react';

class PersonCreate extends React.Component {
  componentDidMount() {
    if (this.props.countries.length === 0) {
      this.props.fetchCountries();
    }
  }

  onSubmit = formValues => {
    this.props.createPersonAndUpdateProject(this.props.projectID, formValues);
  };

  render() {
    const initialVal = {
      countryID: this.props.defaultCountryID
    };

    if (!this.props.defaultCountryID) {
      return <Segment loading />;
    }

    return (
      <Segment>
        <h3>Create Contact</h3>
        <PersonForm
          initialValues={initialVal}
          countries={this.props.countries}
          onSubmit={this.onSubmit}
          onCancel={this.props.onCancel}
        />
      </Segment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    countries: state.countries.items,
    defaultCountryID: state.countries.defaultID
  };
};

const mapDispatchToProps = dispatch => {
  return {
    createPersonAndUpdateProject: (projectID, formValues) =>
      dispatch(actions.createPersonAndUpdateProject(projectID, formValues)),
    fetchCountries: () => dispatch(actions.fetchCountries())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PersonCreate);
